import { IdentifierDTO } from '@zazume/zzm-base';

import { AIPreset } from '#/domain/aiPreset/AIPreset';
import { AITicketReply } from '#/domain/zendeskExtension/AITicketReply';
import { Context } from '#/domain/zendeskExtension/Context';
import { ZendeskTicketField } from '#/domain/zendeskExtension/ZendeskTicketField';
import { doGet, doPost, doPut } from '#lib/network/helpers';

import { GenerateAITicketReplyRequestBody } from './request/GenerateAITicketReplyRequestBody';
import { SetTicketContextMetadataRequestBody } from './request/SetTicketContextMetadataRequestBody';

export const zendeskExtension = {
  getContext: (ticketId: string) => () => doGet<Context>(`/dashboard/zendesk-extension/context/${ticketId}`),
  setTicketContextMetadata: (ticketId: string) => (body: SetTicketContextMetadataRequestBody) =>
    doPut<void>(`/dashboard/zendesk-extension/context/${ticketId}`, body),
  generateAITicketReply: (body: GenerateAITicketReplyRequestBody) =>
    doPost<AITicketReply>(`/dashboard/zendesk-extension/generate-reply/${body.conversationId}`, body),
  generateAITicketSideConversationReply: (conversationId: string) => () =>
    doPost<void>(`/dashboard/zendesk-extension/generate-reply/side-conversation/${conversationId}`),
  findOneLastAIReply: (ticketId: string) => () =>
    doGet<AITicketReply>(`/dashboard/zendesk-extension/reply/${ticketId}`),
  syncTicket: (ticketId: string) => () => doPost<void>(`/dashboard/zendesk-extension/ticket/sync/${ticketId}`),
  updateReplyFeedback: (aiReplyId: IdentifierDTO) => (isPositiveFeedback: boolean) =>
    doPost<void>(`/dashboard/zendesk-extension/reply-feedback/${aiReplyId}`, { isPositiveFeedback }),
  modifyAITicketReplyContent: (aiReplyId: IdentifierDTO) => (newContent: string) =>
    doPost<void>(`/dashboard/zendesk-extension/reply-feedback/content/${aiReplyId}`, { newContent }),
  findOrganizationTicketFields: () => doGet<ZendeskTicketField[]>('/dashboard/zendesk-extension/ticket-fields'),
  getAIPreset: (aiPresetId: IdentifierDTO) => () =>
    doGet<AIPreset>(`/dashboard/zendesk-extension/ticket-fields/${aiPresetId}`),
  findTicketAIPresets: (aiPresetId: IdentifierDTO) => () =>
    doGet<AIPreset[]>(`/dashboard/zendesk-extension/ai-preset/${aiPresetId}`),
  updateAIPreset: (aiPresetId: IdentifierDTO) => body =>
    doPut<void>(`/dashboard/zendesk-extension/ai-preset/${aiPresetId}`, body),
  createTicketFieldAIPreset: body => doPost<void>(`/dashboard/zendesk-extension/ai-preset/${body.fieldId}`, body)
};
